import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { Spinner } from '@/components/ui/spinner'
import { isNativePlatform, listenForAppResume, openNativeCheckout } from '@/lib/native'
import { RoutePath } from '@/RoutePath'

const isPaymentPath = (pathname: string) => pathname.startsWith('/payment/')

export function NativeCheckoutHandoff() {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [error, setError] = useState('')
  const openingRef = useRef(false)

  const pkgId = location.pathname.split('/')[3] || ''

  useEffect(() => {
    if (!isNativePlatform() || !isPaymentPath(location.pathname) || !pkgId || openingRef.current) return

    openingRef.current = true
    setError('')
    void openNativeCheckout(`${location.pathname}${location.search}`, pkgId)
      .catch(() => {
        setError(t('native.checkoutOpenError'))
      })
      .finally(() => {
        openingRef.current = false
      })
  }, [location.pathname, location.search, pkgId, t])

  useEffect(() => {
    if (!isNativePlatform()) return undefined
    return listenForAppResume(() => {
      if (isPaymentPath(location.pathname)) {
        navigate(RoutePath.ClientPkg, { replace: true })
      }
    })
  }, [location.pathname, navigate])

  if (!isNativePlatform() || !isPaymentPath(location.pathname)) return null

  return (
    <div className='bg-background-app flex min-h-[50vh] flex-col items-center justify-center gap-3 p-6 text-center'>
      <Spinner className='size-10' />
      <p className='text-text-primary text-base font-medium'>{t('native.openingCheckout')}</p>
      {error ? <p className='text-sm text-red-600'>{error}</p> : null}
    </div>
  )
}

export function shouldHandoffNativeCheckout(pathname: string): boolean {
  return isNativePlatform() && isPaymentPath(pathname)
}
